<template>
  <div class="room ventilation" v-loading="loadingData">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="device-block-multi">
      <div class="air-wrap" :class="warningFlagTopLeft">
        <div class="air-title">{{ this.stationName }}温湿度</div>
        <div class="air-chart-wrap">
          <SinglePieHistogramWrap
            class="device-block-multi-item"
            :opts="singlePieHistogramWrapOptsTopLeft1"
            :series="singlePieHistogramWrapDataTopLeft1"
            :class="singlePieHistogramWarningFlagTopLeft1"
          ></SinglePieHistogramWrap>
          <SinglePieHistogramWrap
            class="device-block-multi-item"
            :opts="singlePieHistogramWrapOptsTopLeft2"
            :series="singlePieHistogramWrapDataTopLeft2"
            :class="singlePieHistogramWarningFlagTopLeft2"
          ></SinglePieHistogramWrap>
        </div>
      </div>

      <div class="air-wrap" :class="warningFlagTopRight">
        <div class="air-title">{{ this.stationName }}温湿度</div>
        <div class="air-chart-wrap">
          <SinglePieHistogramWrap
            class="device-block-multi-item"
            :opts="singlePieHistogramWrapOptsTopRight1"
            :series="singlePieHistogramWrapDataTopRight1"
            :class="singlePieHistogramWarningFlagTopRight1"
          ></SinglePieHistogramWrap>
          <SinglePieHistogramWrap
            class="device-block-multi-item"
            :opts="singlePieHistogramWrapOptsTopRight2"
            :series="singlePieHistogramWrapDataTopRight2"
            :class="singlePieHistogramWarningFlagTopRight2"
          ></SinglePieHistogramWrap>
        </div>
      </div>
    </div>

    <div class="device-block-line">
      <div class="device-block-line-item">
        <div class="device-block-line-item-top">
          <div class="device-block-line-item-half">
            <SwitchStatus class="switch-item" :title="switchTitleLeftL1" :series="switchDataLeftL1"></SwitchStatus>
            <SwitchStatus class="switch-item" :title="switchTitleLeftL2" :series="switchDataLeftL2"></SwitchStatus>
          </div>
          <div class="device-block-line-item-half">
            <SwitchStatus class="switch-item" :title="switchTitleLeftR1" :series="switchDataLeftR1"></SwitchStatus>
            <SwitchStatus class="switch-item" :title="switchTitleLeftR2" :series="switchDataLeftR2"></SwitchStatus>
          </div>
        </div>
        <RunningTimeBig class="running-time-item" :title="runningTimeTitleLeft" :series="runningTimeDataLeft" :isHour="true"></RunningTimeBig>
      </div>

      <div class="device-block-line-item">
        <div class="device-block-line-item-top">
          <div class="device-block-line-item-half">
            <SwitchStatus class="switch-item" :title="switchTitleRightL1" :series="switchDataRightL1"></SwitchStatus>
            <SwitchStatus class="switch-item" :title="switchTitleRightL2" :series="switchDataRightL2"></SwitchStatus>
          </div>
          <div class="device-block-line-item-half">
            <SwitchStatus class="switch-item" :title="switchTitleRightR1" :series="switchDataRightR1"></SwitchStatus>
            <SwitchStatus class="switch-item" :title="switchTitleRightR2" :series="switchDataRightR2"></SwitchStatus>
          </div>
        </div>
        <RunningTimeBig class="running-time-item" :title="runningTimeTitleRight" :series="runningTimeDataRight" :isHour="true"></RunningTimeBig>
      </div>
    </div>
  </div>
</template>

<script>
import configJson from "./config/steelBoxSideSpan.json";

export default {
  name: "ventilationNew",
  data() {
    return {
      timer: null,
      loading: false,
      loadingData: false,
      stationId: "",
      stationName: "",
      deviceList: [],

      switchTitleLeftL1: "除湿机运行",
      switchTitleLeftL2: "一级除湿",
      switchTitleLeftR1: "除湿机故障",
      switchTitleLeftR2: "二级除湿",
      switchTitleRightL1: "风机运行",
      switchTitleRightL2: "手自动选择",
      switchTitleRightR1: "风机故障",
      switchTitleRightR2: "手动启动",
      runningTimeTitleLeft: "除湿机运行时间",
      runningTimeTitleRight: "风机运行时间",

      singlePieHistogramWrapDataTopLeft1: {},
      singlePieHistogramWrapDataTopLeft2: {},
      singlePieHistogramWrapDataTopRight1: {},
      singlePieHistogramWrapDataTopRight2: {},

      switchDataLeftL1: {},
      switchDataLeftL2: {},
      switchDataLeftR1: {},
      switchDataLeftR2: {},
      switchDataRightL1: {},
      switchDataRightL2: {},
      switchDataRightR1: {},
      switchDataRightR2: {},

      runningTimeDataLeft: null,
      runningTimeDataRight: null,

      warningFlagTopLeft: "",
      warningFlagTopRight: "",

      singlePieHistogramWarningFlagTopLeft1: "",
      singlePieHistogramWarningFlagTopLeft2: "",
      singlePieHistogramWarningFlagTopRight1: "",
      singlePieHistogramWarningFlagTopRight2: "",
    };
  },
  computed: {
    singlePieHistogramWrapOptsTopLeft1: function () {
      return {
        title: "南边跨温湿度1",
        histogramName1: "T",
        center1: ["52%", "60%"],
        radius1: ["40%", "55%"],
        pieName1: "RH",
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: "°C",
      };
    },
    singlePieHistogramWrapOptsTopLeft2: function () {
      return {
        title: "南边跨温湿度2",
        histogramName1: "T",
        center1: ["52%", "60%"],
        radius1: ["40%", "55%"],
        pieName1: "RH",
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: "°C",
      };
    },

    singlePieHistogramWrapOptsTopRight1: function () {
      return {
        title: "南边跨温湿度3",
        histogramName1: "T",
        center1: ["52%", "60%"],
        radius1: ["40%", "55%"],
        pieName1: "RH",
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: "°C",
      };
    },
    singlePieHistogramWrapOptsTopRight2: function () {
      return {
        title: "南边跨温湿度4",
        histogramName1: "T",
        center1: ["52%", "60%"],
        radius1: ["40%", "55%"],
        pieName1: "RH",
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: "°C",
      };
    },
  },
  created() {
    this.readConfig();
  },
  mounted() {
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  watch: {
    /**
     * 监听路由变化
     * @param {Object} route # 当前路由信息
     */
    $route(route) {
      this.resetData();
      this.readConfig();
      this.loadingData = true;
      this.getData();
    },
  },
  methods: {
    readConfig() {
      const routerPath = this.$route.fullPath.split("/");
      this.deviceList = configJson[routerPath[3]].deviceList;
      // const deviceName = configJson[routerPath[3]].deviceName;
      // this.deviceLeftName = deviceName.deviceLeftName;
      // this.deviceRightName = deviceName.deviceRightName;
      this.stationId = configJson[routerPath[3]].stationId;
      this.stationName = configJson[routerPath[3]].stationName;
      this.bridgeSegmentName = configJson[routerPath[3]].bridgeSegmentName;

      this.areaName1 = configJson[routerPath[3]].areaName1;
      this.areaName2 = configJson[routerPath[3]].areaName2;
      this.areaName3 = configJson[routerPath[3]].areaName3;
    },
    resetData() {
      this.warningFlagTopLeft = "";
      this.warningFlagTopRight = "";
    },
    refreshData() {
      this.loadingData = true;
      this.getData();
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.getData();
      }, this.REFRESH_SECOND);
    },
    findDeviceId(deviceName) {
      const device = this.deviceList.find((el) => {
        return el.deviceName === deviceName;
      });
      if (!device) {
        console.log(`deviceName${deviceName}###`);
      }
      return device.deviceId || "";
    },
    getCurrentData(stationId) {
      return this.$http.get(`/deviceData/Station?stationId=${stationId}`);
    },
    getData() {
      let request = this.getCurrentData(this.stationId);
      request.then((res) => {
        setTimeout(() => {
          this.loadingData = false;
        }, 500);
        let currentData = res.data;

        this.setPieHistogramDataAndError(
          currentData,
          "singlePieHistogramWrapDataTopLeft1",
          "南边跨温度1",
          "南边跨湿度1",
          "singlePieHistogramWarningFlagTopLeft1"
        );
        this.setPieHistogramDataAndError(
          currentData,
          "singlePieHistogramWrapDataTopLeft2",
          "南边跨温度2",
          "南边跨湿度2",
          "singlePieHistogramWarningFlagTopLeft2"
        );

        this.setPieHistogramDataAndError(
          currentData,
          "singlePieHistogramWrapDataTopRight1",
          "南边跨温度3",
          "南边跨湿度3",
          "singlePieHistogramWarningFlagTopRight1"
        );
        this.setPieHistogramDataAndError(
          currentData,
          "singlePieHistogramWrapDataTopRight2",
          "南边跨温度4",
          "南边跨湿度4",
          "singlePieHistogramWarningFlagTopRight2"
        );

        const switchIdLeftL1 = this.findDeviceId(this.switchTitleLeftL1);
        const switchIdLeftL2 = this.findDeviceId(this.switchTitleLeftL2);
        const switchIdLeftR1 = this.findDeviceId(this.switchTitleLeftR1);
        const switchIdLeftR2 = this.findDeviceId(this.switchTitleLeftR2);
        this.switchDataLeftL1 = {
          data: currentData[switchIdLeftL1].value,
          isError: currentData[switchIdLeftL1].errorLevel,
        };
        this.switchDataLeftL2 = {
          data: currentData[switchIdLeftL2].value,
          isError: currentData[switchIdLeftL2].errorLevel,
        };
        this.switchDataLeftR1 = {
          data: currentData[switchIdLeftR1].value,
          isError: currentData[switchIdLeftR1].errorLevel,
          isZh: true,
        };
        this.switchDataLeftR2 = {
          data: currentData[switchIdLeftR2].value,
          isError: currentData[switchIdLeftR2].errorLevel,
        };

        const switchIdRightL1 = this.findDeviceId(this.switchTitleRightL1);
        const switchIdRightL2 = this.findDeviceId(this.switchTitleRightL2);
        const switchIdRightR1 = this.findDeviceId(this.switchTitleRightR1);
        const switchIdRightR2 = this.findDeviceId(this.switchTitleRightR2);
        this.switchDataRightL1 = {
          data: currentData[switchIdRightL1].value,
          isError: currentData[switchIdRightL1].errorLevel,
        };
        this.switchDataRightL2 = {
          data: currentData[switchIdRightL2].value,
          isError: currentData[switchIdRightL2].errorLevel,
          textOff: "自动",
          textOn: "手动",
        };
        this.switchDataRightR1 = {
          data: currentData[switchIdRightR1].value,
          isError: currentData[switchIdRightR1].errorLevel,
          isZh: true,
        };
        this.switchDataRightR2 = {
          data: currentData[switchIdRightR2].value,
          isError: currentData[switchIdRightR2].errorLevel,
        };

        const runningTimeIdLeft = this.findDeviceId(this.runningTimeTitleLeft);
        const runningTimeIdRight = this.findDeviceId(this.runningTimeTitleRight);
        this.runningTimeDataLeft = currentData[runningTimeIdLeft].value;
        this.runningTimeDataRight = currentData[runningTimeIdRight].value;
      });
    },

    setPieHistogramDataAndError(currentData, echartSeriesDataName, temperatureName, humidityName, warningFlagName) {
      const temperatureId = this.findDeviceId(temperatureName);
      const humidityId = this.findDeviceId(humidityName);
      this[echartSeriesDataName] = {
        data1: currentData[temperatureId].value,
        data2: currentData[humidityId].value,
      };

      let errorLevel = this.getErrorLevelFromMultipleDevice(currentData[temperatureId].errorLevel, this[warningFlagName]);
      errorLevel = this.getErrorLevelFromMultipleDevice(currentData[humidityId].errorLevel, this[warningFlagName]);
      this[warningFlagName] = errorLevel;
    },

    setLineData(temperatureData, humidityData, echartSeriesDataName, warningFlagName) {
      let data1 = {};
      let data2 = {};
      temperatureData.data.dataList.forEach((item, index) => {
        data1[item.StatisticsDate] = item.value;
      });
      humidityData.data.dataList.forEach((item, index) => {
        data2[item.StatisticsDate] = item.value;
      });

      this[echartSeriesDataName] = {
        data1: data1,
        data2: data2,
      };

      let errorLevel = this.getErrorLevelFromMultipleDevice(temperatureData.data.errorLevel, this[warningFlagName]);
      errorLevel = this.getErrorLevelFromMultipleDevice(humidityData.data.errorLevel, this[warningFlagName]);
      this[warningFlagName] = errorLevel;
    },

    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === "Error") {
        return "Error";
      } else if (currentErrorLevel === "Warning") {
        if (newErrorLevel === "Error") {
          return "Error";
        } else {
          return "Warning";
        }
      } else {
        return newErrorLevel;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ventilation {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: stretch;
  align-content: stretch;
  padding-top: 10px;

  .device-block-multi {
    width: 100%;
    height: calc(50% - 15px);
    background-color: transparent;
    display: flex;
    justify-content: space-between;
    align-items: stretch;

    .device-block {
      width: calc(50% - 10px);
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: stretch;
      position: relative;

      .device-block-line-chart {
        width: 75%;
        height: 100%;
      }

      .device-block-bar-chart {
        width: 24%;
        height: 100%;
      }
    }
  }

  .device-block-line {
    width: 100%;
    height: calc(50% - 15px);
    background-color: transparent;
    display: flex;
    justify-content: space-between;
    align-items: stretch;

    .device-block-line-item {
      width: calc(50% - 9px);
      display: flex;
      box-sizing: border-box;
      justify-content: space-between;
      flex-direction: column;
      align-items: stretch;

      .device-block-line-item-half {
        display: flex;
        height: 100%;
        width: calc(50% - 7px);
        flex-direction: column;
        justify-content: space-between;
      }

      .device-block-line-item-top {
        display: flex;
        justify-content: space-between;
        height: 60px;
        width: 100%;
      }

      .device-block-line-item-bottom {
        display: flex;
        justify-content: space-between;
        height: calc(100% - 290px);
        width: 100%;
      }

      .switch-item {
        height: 38px;
        width: 100%;
        box-sizing: border-box;
        flex-shrink: 0;
        margin-bottom: 10px;
        &:last-child {
          margin-bottom: 0;
        }
      }

      .divice-block-thin {
        height: calc(50% - 5px);
        width: 100%;
        box-sizing: border-box;
        flex-shrink: 0;
        margin-bottom: 10px;
        &:last-child {
          margin-bottom: 0;
        }
      }

      .running-time-item {
        height: calc(100% - 95px);
        width: 100%;
        box-sizing: border-box;
      }

      &.single-chart-item {
        background-color: rgba(255, 255, 255, 0.6);
      }
    }
  }

  .air-wrap {
    box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    padding: 0 10px;
    width: calc(50% - 10px);
    height: 100%;
    background-color: rgba(255, 255, 255, 0.6);
    box-sizing: border-box;

    .air-title {
      padding: 20px 15px 10px 10px;
      font-size: 22px;
      color: #515151;
    }

    .air-chart-wrap {
      height: 80%;
      display: flex;
      flex: 1;
    }

    // .air-chart-wrap {
    //   width: calc(50% - 10px);
    //   height: 100%;
    //   display: flex;
    //   flex: 1;
    //   justify-content: space-between;
    //   align-items: stretch;
    //   position: relative;
    // }

    .air-chart {
      padding: 20px 0;
      box-sizing: border-box;
      width: 33.3333%;

      .device-block-multi-item {
        width: calc((100% / 3) - 10px);
        height: 100%;
        background-color: rgba(255, 255, 255, 0.6);
      }
    }
  }
}
</style>
